import React from 'react';
import { AddressForm } from './AddressForm';
import { AddressFormSkeleton } from './AddressFormSkeleton';
import type { AddressFields, AddressUpdateResponse, AddressValues } from './types';
import { FrontOverlay, type FrontOverlayMode } from '../../../ips-react-front-fw/components/overlay';

type Props = {
  open: boolean;
  mode?: FrontOverlayMode;
  onClose: () => void;
  title: string;
  fields: AddressFields | null;
  values: AddressValues;
  loading: boolean;
  saving: boolean;
  error: string | null;
  onChange: (key: string, val: string) => void;
  onSubmit: () => Promise<AddressUpdateResponse | null>;
  onSaved?: (result: AddressUpdateResponse | null) => void;
};

export const AddressDrawer: React.FC<Props> = ({
  open,
  mode = 'drawer',
  onClose,
  title,
  fields,
  values,
  loading,
  saving,
  error,
  onChange,
  onSubmit,
  onSaved,
}) => {
  if (!open) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await onSubmit();
    onSaved?.(result);
    onClose();
  };

  return (
    <FrontOverlay open={open} mode={mode} onClose={onClose}>
      <div className="ips-front-address-editor">
        <header className="ips-front-address-editor__header">
          <h3>{title}</h3>
          <button type="button" onClick={onClose} aria-label="Close">
            ×
          </button>
        </header>
        <div className="ips-front-address-editor__body">
          {loading && <AddressFormSkeleton />}
          {error && <p className="ips-front-address-editor__error">{error}</p>}
          {!loading && fields && (
            <form onSubmit={handleSubmit}>
              <AddressForm fields={fields} values={values} onChange={onChange} />
              <div className="ips-front-address-editor__footer">
                <button type="button" onClick={onClose} className="secondary">
                  Abbrechen
                </button>
                <button type="submit" disabled={saving}>
                  {saving ? 'Speichern …' : 'Speichern'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </FrontOverlay>
  );
};
